import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Form,
  Divider,
  FormGroup,
  FormField,
  Button
} from 'semantic-ui-react'

const CardWorkPlanUX = (props: any) => {
    return(
      <div
        id="CardWorkPlanUX-div-0"
        style={{width: "100%", height:"100%", padding:"8px 0"}}>
        <Form
          id="CardWorkPlanUX-Form-1">
          <FormGroup
            id="CardWorkPlanUX-FormGroup-4"
            inline={true}
            style={{margin: "2px", marginBottom: "0.5rem", padding: "0 8px"}}>
            <FormField
              id="CardWorkPlanUX-FormField-5"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("ProjectList")?"":"none"}}>
              <Button
                color={props.activeTab === "ProjectList" ? "blue" : undefined}
                id="CardWorkPlanUX-Button-7"
                onClick={() => props.onHandleChangeTab("ProjectList")}
                size="small">
                Project List
              </Button>
            </FormField>
            <FormField
              id="CardWorkPlanUX-FormField-6"
              inline={true}
              style={{display: props.filteredTabMenu?.includes("IssueList")?"":"none"}}>
              <Button
                color={props.activeTab === "IssueList" ? "blue" : undefined}
                id="CardWorkPlanUX-Button-8"
                onClick={() => props.onHandleChangeTab("IssueList")}
                size="small">
                Issue List
              </Button>
            </FormField>
          </FormGroup>
        </Form>
        <Divider
          fitted={true}
          id="CardWorkPlanUX-Divider-2">
        </Divider>
        <div
          id="CardWorkPlanUX-div-3">
          {props.displayTab}
        </div>
      </div>
    )
}


export default CardWorkPlanUX

export const screenPropsDefault = {}

/* Date Time : Wed Jul 09 2025 17:50:56 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkPlanUX-div-0"
        },
        "style": {
          "type": "code",
          "value": "{width: \"100%\", height:\"100%\", padding:\"8px 0\"}"
        }
      },
      "seq": 0
    },
    {
      "from": "semantic-ui-react",
      "id": 1,
      "name": "Form",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkPlanUX-Form-1"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Divider",
      "parent": 0,
      "props": {
        "fitted": {
          "type": "code",
          "value": "true"
        },
        "id": {
          "type": "value",
          "value": "CardWorkPlanUX-Divider-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "code",
          "value": "props.displayTab"
        },
        "id": {
          "type": "value",
          "value": "CardWorkPlanUX-div-3"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 4,
      "name": "FormGroup",
      "parent": 1,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkPlanUX-FormGroup-4"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"2px\", marginBottom: \"0.5rem\", padding: \"0 8px\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 5,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkPlanUX-FormField-5"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"ProjectList\")?\"\":\"none\"}"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 6,
      "name": "FormField",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardWorkPlanUX-FormField-6"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{display: props.filteredTabMenu?.includes(\"IssueList\")?\"\":\"none\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 7,
      "name": "Button",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": "Project List"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"ProjectList\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardWorkPlanUX-Button-7"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"ProjectList\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 8,
      "name": "Button",
      "parent": 6,
      "props": {
        "children": {
          "type": "value",
          "value": "Issue List"
        },
        "color": {
          "type": "code",
          "value": "props.activeTab === \"IssueList\" ? \"blue\" : undefined"
        },
        "id": {
          "type": "value",
          "value": "CardWorkPlanUX-Button-8"
        },
        "onClick": {
          "type": "code",
          "value": "() => props.onHandleChangeTab(\"IssueList\")"
        },
        "size": {
          "type": "value",
          "value": "small"
        }
      },
      "seq": 8,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "name": "CardWorkPlanUX",
  "project": "IsHealth",
  "screenPropsDefault": {
  },
  "width": 80
}

*********************************************************************************** */
